import { render } from "./Container.vue?vue&type=template&id=8cc1b22e&scoped=true"
const script = {}

import "./Container.vue?vue&type=style&index=0&id=8cc1b22e&scoped=true&lang=css"

import exportComponent from "/Users/ilvinipitter/code/lider-fornecedores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cc1b22e"]])

export default __exports__